import { render, staticRenderFns } from "./upLoadNeed.vue?vue&type=template&id=1fb7d008&scoped=true"
import script from "./upLoadNeed.vue?vue&type=script&lang=js"
export * from "./upLoadNeed.vue?vue&type=script&lang=js"
import style0 from "./upLoadNeed.vue?vue&type=style&index=0&id=1fb7d008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb7d008",
  null
  
)

export default component.exports